import { render, staticRenderFns } from "./porderClaimIndemnity.vue?vue&type=template&id=42042ef0&scoped=true&"
import script from "./porderClaimIndemnity.vue?vue&type=script&lang=js&"
export * from "./porderClaimIndemnity.vue?vue&type=script&lang=js&"
import style0 from "./porderClaimIndemnity.vue?vue&type=style&index=0&id=42042ef0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42042ef0",
  null
  
)

export default component.exports